// import React, { useRef, useEffect, useState, useMemo } from "react";
// import { Row, Col, Card, Typography, Select, Button, Pagination } from "antd";
// import LeadCard from "./LeadCard";
// import AdminCard from "./AdminCard";
// import { FilterOutlined } from "@ant-design/icons";
// import { useLocation, useNavigate } from "react-router-dom";
// import { connect, useDispatch } from "react-redux";
// import "./newDashboard.css";
// import useLeadOptions from "../../components/NewDashboard/UseLeadOptions";
// import axiosPublic from "../../store/api/axiosPublic";
// import useBeforeLoginApi from "../../hooks/useBeforeLoginApi";
// import Header from "../../components/Header";
// import { formatAmountIndian } from "./FormatAmount";

// const BeforeLoginWeb = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { Title } = Typography;
//   const dispatch = useDispatch();
//   const [selectedLead, setSelectedLead] = useState(null);
//   // const [cartLeads, setCartLeads] = useState([]);
//   const [subcategoryLeadsMap, setSubcategoryLeadsMap] = useState({});
//   const [subcategoryLoading, setSubcategoryLoading] = useState({});
//   const [lastSearchParams, setLastSearchParams] = useState({});

//   const [locations, setLocations] = useState([]);
//   const [landTypes, setLandTypes] = useState([]);
//   const [budgets, setBudgets] = useState([]);
//   const [filters, setFilters] = useState({
//     location: [],
//     landType: [],
//     budget: [],
//     plotSize: [],
//   });

//   const filterLeads = location.state?.filters;
//   const [filteredLeadsNav, setFilteredLeadsNav] = useState([]);
//   // const [loadingFiltered, setLoadingFiltered] = useState(false);
//   const rightColRef = useRef(null);
//   const [rightColPos, setRightColPos] = useState({ left: 0, width: 0 });

//   // Fetch leads
//   const {
//     allLeads,
//     pagination,
//     cartLeads,
//     loading,
//     fetchAllLeads,
//     updateLeadSubCategory,
//     addLeadToCart,
//     removeLeadFromCart,
//   } = useBeforeLoginApi();

//   const transformLeadData = (rawLead) => ({
//     id: rawLead._id,
//     name: rawLead.name,
//     place: rawLead.location,
//     price: rawLead.budget,
//     currentRate: rawLead.currentRate,
//     landType: rawLead.subcategory?.label || "",
//     rating: `${rawLead.timesBought || 0}/${rawLead.leadAvailableCount || 0}`,
//     status: rawLead.status || "",
//     siteVisit: rawLead.siteVisitDays?.join(", ") || "",
//     lookingFor:
//       rawLead.property_details ||
//       rawLead.category?.label ||
//       "No details provided",
//     contact: rawLead.phone,
//     type: rawLead.leadType,
//     category: rawLead.category,
//     sqft: rawLead.spaceSqft || 0,
//     subCategoryId: rawLead.subcategory?._id,
//     subCategoryLabel: rawLead.subcategory?.label || "",
//     subCategoryName: rawLead.subcategory?.name || "",
//     state: rawLead.state || "",
//     district: rawLead.district || "",
//     area: rawLead.area || "",
//     pincode: rawLead.pincode || "",
//   });
//   console.log("leads", allLeads);
//   console.log("pagination", pagination);

//   // Update right column position
//   useEffect(() => {
//     const updatePosition = () => {
//       if (rightColRef.current) {
//         const rect = rightColRef.current.getBoundingClientRect();
//         setRightColPos({ left: rect.left, width: rect.width });
//       }
//     };
//     updatePosition();
//     window.addEventListener("resize", updatePosition);
//     return () => window.removeEventListener("resize", updatePosition);
//   }, []);

//   const fetchFilteredLeadsFromPage = async (filters) => {
//     try {
//       const URL = "https://apilead.blaccdot.com/api/admin/all-leads";

//       const params = {
//         state: filters?.state || undefined,
//         district: filters?.district || undefined,
//         area: filters?.area || undefined,
//         pincode: filters?.pincode || undefined,

//         category:
//           Array.isArray(filters?.landType) && filters.landType.length
//             ? filters.landType.join(",")
//             : undefined,

//         minBudget:
//           Array.isArray(filters?.budget) && filters.budget.length === 2
//             ? filters.budget[0]
//             : undefined,

//         maxBudget:
//           Array.isArray(filters?.budget) && filters.budget.length === 2
//             ? filters.budget[1]
//             : undefined,
//       };

//       Object.keys(params).forEach(
//         (key) => params[key] === undefined && delete params[key],
//       );

//       console.log("🔵 FILTER PARAMS:", params);

//       const res = await axiosPublic.get(URL, { params });

//       const leads = res.data?.data || [];
//       setFilteredLeadsNav(leads);
//     } catch (error) {
//       console.error("❌ Filter API error:", error);
//       setFilteredLeadsNav([]);
//     }
//   };

//   useEffect(() => {
//     if (filterLeads) {
//       fetchFilteredLeadsFromPage(filterLeads);
//     }
//   }, [filterLeads]);

//   useEffect(() => {
//     if (filterLeads && Object.keys(filterLeads).length > 0) {
//       fetchFilteredLeadsFromPage(filterLeads);

//       // CLEAR STATE: This prevents the filter from persisting on refresh
//       navigate(location.pathname, { replace: true, state: {} });
//     }
//   }, [filterLeads, navigate, location.pathname]);

//   const apiLeads = Array.isArray(allLeads) ? allLeads : [];
//   const totalLeads = pagination.total;
//   const pageSize = pagination.limit;

//   const leads = apiLeads.map((lead) => ({
//     id: lead._id,
//     name: lead.name,
//     place: lead.location,
//     price: lead.budget,
//     landType: lead.subcategory?.label || "",
//     rating: `${lead.timesBought || 0}/${lead.leadAvailableCount || 0}`,
//     status: lead.status || "",
//     siteVisit: lead.siteVisitDays?.join(", ") || "",
//     lookingFor: lead.property_details || "",
//     contact: lead.phone,
//     type: lead.leadType,
//     category: lead.category,
//     sqft: lead.spaceSqft || 0,
//     subCategoryId: lead.subcategory?._id,
//     subCategoryLabel: lead.subcategory?.label || "",
//     subCategoryName: lead.subcategory?.name || "",
//     state: lead.state || "",
//     district: lead.district || "",
//     area: lead.area || "",
//     pincode: lead.pincode || "",
//   }));

//   // Priority lead
//   const priorityLead = leads.find((lead) => {
//     const [purchased, total] = (lead.rating || "0/0").split("/").map(Number);
//     return total - purchased === 1;
//   });

//   const adminLead = priorityLead
//     ? priorityLead
//     : leads[Math.floor(Math.random() * leads.length)] || {};

//   const fetchCommonOptions = async (field, setter) => {
//     try {
//       const res = await axiosPublic.get("admin/publicleads/common", {
//         params: { field },
//       });

//       const options = (res.data?.data || []).map((item) => {
//         const val = item.value; // don’t use .trim(), keep numbers as-is
//         const label =
//           typeof val === "number"
//             ? `${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(val)}`
//             : `${val?.trim()}`; // only trim strings
//         return {
//           value: val,
//           label: label,
//         };
//       });

//       setter(options);
//     } catch (err) {
//       console.error(`Failed to load ${field}`, err);
//     }
//   };

//   useEffect(() => {
//     fetchCommonOptions("location", setLocations);
//     fetchCommonOptions("landType", setLandTypes);
//     fetchCommonOptions("budget", setBudgets);
//   }, []);

//   const subCategoryOptions = [
//     { label: "Plot", value: "plot" },
//     { label: "Villa", value: "villa" },
//     { label: "Apartment", value: "apartment" },
//     { label: "Office", value: "office" },
//     { label: "Shop", value: "shop" },
//   ];

//   const getSelectedLeadIdFromURL = () => {
//     const params = new URLSearchParams(location.search);
//     return params.get("selectedleadid"); // returns the string ID or null
//   };

//   const selectedLeadIdFromURL = new URLSearchParams(location.search).get(
//     "selectedleadid",
//   );

//   useEffect(() => {
//     if (!selectedLeadIdFromURL) return;

//     fetchAllLeads(1, {
//       ...lastSearchParams,
//       leadId: selectedLeadIdFromURL,
//     });
//   }, [selectedLeadIdFromURL]);

//   useEffect(() => {
//     if (!selectedLeadIdFromURL || !allLeads.length) return;

//     const foundLead = allLeads.find(
//       (lead) => lead._id === selectedLeadIdFromURL,
//     );

//     if (foundLead) {
//       setSelectedLead(transformLeadData(foundLead));
//     }
//   }, [allLeads, selectedLeadIdFromURL]);

//   // Cart handlers
//   const handleLeadCheck = async (lead, isChecked) => {
//     if (isChecked) {
//       await addLeadToCart(lead);
//     } else {
//       await removeLeadFromCart(lead.id);
//     }
//   };

//   const handleFilter = () => navigate("/sign-up");
//   const handleClearSearchFilter = () => {
//     // 1. Clear local UI dropdowns
//     setFilters({
//       location: [],
//       landType: [],
//       budget: [],
//       plotSize: [],
//     });
//     setLastSearchParams({});
//     fetchAllLeads(1, {});

//     // 2. Clear the leads fetched via API
//     setFilteredLeadsNav([]);

//     // 3. IMPORTANT: Clear the Navigation/URL state
//     // This prevents the filter from coming back on refresh
//     navigate(location.pathname, { replace: true, state: {} });
//   };

//   const groupedBySubCategory = React.useMemo(() => {
//     if (!Array.isArray(leads) || leads.length === 0) return {};

//     return leads.reduce((acc, lead) => {
//       const label = lead.subCategoryLabel;

//       if (!acc[label]) {
//         acc[label] = [];
//       }

//       acc[label].push(lead);
//       return acc;
//     }, {});
//   }, [leads]);

//   const handleSearch = () => {
//     const params = {};

//     if (filters.location?.length) {
//       params.location = filters.location.join(",");
//     }

//     if (filters.landType?.length) {
//       params.landType = filters.landType.join(",");
//     }

//     if (filters.budget?.length) {
//       params.budget = filters.budget.join(",");
//     }

//     setLastSearchParams(params);
//     fetchAllLeads(1, params);
//   };

//   // const subCategoryCards = Object.entries(groupedBySubCategory).map(
//   //   ([subCategory, leads]) => ({
//   //     subCategory,
//   //     count: leads.length,
//   //     leads,
//   //   }),
//   // );

//   const leadsToRender =
//     filteredLeadsNav.length > 0
//       ? filteredLeadsNav.map(transformLeadData) // transform filter API leads
//       : allLeads.map(transformLeadData); // transform hook leads

//   const handleAddToCart = async () => {
//     navigate("/sign-up");
//   };

//   const fetchLeadsBySubcategory = async (subcat) => {
//     setSubcategoryLoading((p) => ({ ...p, [subcat]: true }));

//     try {
//       const res = await axiosPublic.get(
//         `admin/publicleads/subcategory/${subcat}`,
//       );

//       const leads = Array.isArray(res.data?.data)
//         ? res.data.data.map(transformLeadData)
//         : [];

//       setSubcategoryLeadsMap((prev) => ({
//         ...prev,
//         [subcat]: leads,
//       }));
//     } catch (err) {
//       console.error(`Failed to fetch ${subcat} leads`, err);
//       setSubcategoryLeadsMap((prev) => ({
//         ...prev,
//         [subcat]: [],
//       }));
//     } finally {
//       setSubcategoryLoading((p) => ({ ...p, [subcat]: false }));
//     }
//   };

//   useEffect(() => {
//     subCategoryOptions.forEach((sc) => {
//       fetchLeadsBySubcategory(sc.value);
//     });
//   }, []);

//   const sortedSubCategories = useMemo(() => {
//     return [...subCategoryOptions].sort((a, b) => {
//       const aLen = subcategoryLeadsMap[a.value]?.length || 0;
//       const bLen = subcategoryLeadsMap[b.value]?.length || 0;
//       return bLen - aLen; // descending
//     });
//   }, [subCategoryOptions, subcategoryLeadsMap]);

//   return (
//     <div>
//       <Header />
//       <div style={{ padding: "20px" }}>
//         {/* Page Title & Filters */}
//         <Row gutter={16} align="middle" style={{ marginBottom: "16px" }}>
//           <Col
//             span={7}
//             style={{ display: "flex", alignItems: "center", gap: "10px" }}
//           >
//             <Title level={4} style={{ margin: 0 }}>
//               All Leads
//             </Title>

//             {/* Filtered Flag & Clear Link */}
//             {filteredLeadsNav.length > 0 && (
//               <div
//                 style={{ display: "flex", alignItems: "center", gap: "8px" }}
//               >
//                 {/* <span
//                   style={{
//                     background: "#e6f7ff",
//                     color: "#1890ff",
//                     padding: "2px 8px",
//                     borderRadius: "4px",
//                     fontSize: "12px",
//                     border: "1px solid #91d5ff",
//                   }}
//                 >
//                   collection form
//                 </span> */}
//                 <Button
//                   type="link"
//                   size="small"
//                   onClick={handleClearSearchFilter}
//                   style={{ padding: 0, height: "auto", fontSize: "12px" }}
//                 >
//                   Clear
//                 </Button>
//               </div>
//             )}
//           </Col>

//           <Col span={12}>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 border: "1px solid #DBEAFF",
//                 borderRadius: 6,
//                 overflow: "hidden",
//                 background: "#fff",
//                 width: "100%",
//               }}
//             >
//               <Select
//                 mode="multiple"
//                 className="custom-select"
//                 placeholder="Select Location"
//                 style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
//                 value={filters.location}
//                 onChange={(values) =>
//                   setFilters((prev) => ({ ...prev, location: values }))
//                 }
//                 options={locations}
//               />

//               <Select
//                 mode="multiple"
//                 className="custom-select"
//                 placeholder="Land Type"
//                 style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
//                 value={filters.landType}
//                 onChange={(values) =>
//                   setFilters({ ...filters, landType: values })
//                 }
//                 options={landTypes}
//               />
//               <Select
//                 mode="multiple"
//                 className="custom-select"
//                 placeholder="Budget Range"
//                 style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
//                 value={filters.budget}
//                 onChange={(values) =>
//                   setFilters({ ...filters, budget: values })
//                 }
//                 options={budgets}
//               />

//               <Button
//                 type="primary"
//                 style={{
//                   background: "blue",
//                   border: "none",
//                   borderRadius: 0,
//                   padding: "0 24px",
//                 }}
//                 onClick={handleSearch}
//               >
//                 Search
//               </Button>
//             </div>
//           </Col>
//           <Col span={2} style={{ paddingRight: 0 }}>
//             <Button
//               type="default"
//               onClick={handleClearSearchFilter}
//               style={{ border: "1px solid red", color: "red" }}
//             >
//               Clear
//             </Button>
//           </Col>
//           <Col span={2}>
//             <Button
//               icon={<FilterOutlined />}
//               type="default"
//               onClick={handleFilter}
//             >
//               Notify leads
//             </Button>
//           </Col>
//         </Row>

//         {/* Leads & Admin Card */}
//         <Row gutter={20}>
//           <Col span={7}>
//             {leadsToRender.map((lead) => (
//               <LeadCard
//                 key={lead.id}
//                 {...lead}
//                 showCheckbox
//                 checked={cartLeads.some((l) => l.id === lead.id)}
//                 onCheck={(id, checked) => {
//                   if (checked) {
//                     addLeadToCart(lead);
//                   } else {
//                     removeLeadFromCart(id);
//                   }
//                 }}
//                 onClick={() =>
//                   setSelectedLead({
//                     ...lead,
//                   })
//                 }
//                 isSelected={selectedLead?.id === lead.id}
//               />
//             ))}

//             <Pagination
//               simple
//               showSizeChanger={false}
//               current={pagination.page}
//               total={pagination.total || 10}
//               pageSize={pagination.limit}
//               onChange={(page) => fetchAllLeads(page, lastSearchParams)}
//             />
//           </Col>

//           <Col flex="2px">
//             <div
//               style={{ width: 2, backgroundColor: "#DBEAFF", height: "100%" }}
//             />
//           </Col>

//           <Col span={16} ref={rightColRef}>
//             {selectedLead ? (
//               <>
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 12,
//                   }}
//                 >
//                   <Typography.Title level={4} style={{ margin: 0 }}>
//                     Lead Details
//                   </Typography.Title>

//                   {/* <Select
//                   placeholder="Update Subcategory"
//                   // value={selectedLead?.subCategoryId}

//                   value={selectedLead?.subCategoryLabel?.toLowerCase()}
//                   style={{ width: 220 }}
//                   options={subCategoryOptions}
//                   onChange={async (selectedValue) => {
//                     await updateLeadSubCategory(selectedLead.id, selectedValue);

//                     setSelectedLead((prev) => ({
//                       ...prev,
//                       subCategoryLabel: selectedValue,
//                       subCategoryName: selectedValue,
//                     }));
//                   }}
//                 /> */}
//                 </div>

//                 <Card
//                   style={{
//                     borderRadius: 6,
//                     background: "#fafafa",
//                     marginBottom: 20,
//                   }}
//                 >
//                   <Row gutter={0}>
//                     <Col span={6} className="search-select-divider col-padding">
//                       <strong>Name</strong>
//                       <p>{selectedLead.name}</p>
//                     </Col>
//                     <Col span={6} className="search-select-divider col-padding">
//                       <strong>Contact No.</strong>
//                       <p>{selectedLead.contact}</p>
//                     </Col>
//                     <Col span={6} className="search-select-divider col-padding">
//                       <strong>Client Location</strong>
//                       <p>{selectedLead.place}</p>
//                     </Col>
//                     <Col span={6} className="col-padding">
//                       <strong>Sq.ft</strong>
//                       <p>{selectedLead.sqft}</p>
//                     </Col>
//                   </Row>
//                   <Row gutter={0} style={{ marginTop: 10 }}>
//                     <Col span={6} className="search-select-divider col-padding">
//                       <strong>Budget</strong>
//                       <p>₹ {formatAmountIndian(selectedLead.price)}</p>
//                     </Col>
//                     <Col span={6} className="search-select-divider col-padding">
//                       <strong>Preferred location</strong>
//                       <p>
//                         {selectedLead?.state || ""}-
//                         {selectedLead?.district || ""}-
//                         {selectedLead?.area || ""}--
//                         {selectedLead?.pincode || ""}
//                       </p>
//                     </Col>
//                     <Col span={6} className="search-select-divider col-padding">
//                       <strong>Site Visit</strong>
//                       <p>{selectedLead.siteVisit}</p>
//                     </Col>

//                     <Col span={6} className="col-padding">
//                       <strong>Looking For</strong>
//                       <p>{selectedLead.lookingFor}</p>
//                     </Col>
//                   </Row>
//                   <Button
//                     style={{
//                       background: "blue",
//                       color: "white",
//                       marginTop: 16,
//                     }}
//                     onClick={() => addLeadToCart(selectedLead, true)}
//                   >
//                     Buy Now
//                   </Button>
//                 </Card>
//               </>
//             ) : (
//               <AdminCard
//                 {...adminLead}
//                 onTopPickClick={(leadId) =>
//                   navigate(`/retail-leads?selectedleadid=${leadId}`)
//                 }
//                 // onBuyNow={(l) => addLeadToCart(l, true)}
//               />
//             )}
//             <div
//               className="thin-scroll"
//               style={{
//                 display: "flex",
//                 gap: "16px",
//                 overflowX: "auto",
//                 paddingBottom: "8px",
//               }}
//             >
//               {sortedSubCategories.map((sc) => {
//                 const leads = subcategoryLeadsMap[sc.value] || [];
//                 const loading = subcategoryLoading[sc.value];

//                 return (
//                   <div
//                     className="thin-scroll"
//                     key={sc.value}
//                     style={{
//                       minWidth: 300,
//                       maxHeight: 360,
//                       background: "#f9fafb",
//                       border: "1px solid #e5e7eb",
//                       borderRadius: 6,
//                       overflowY: "auto",
//                     }}
//                   >
//                     {/* Sticky header */}
//                     <h5
//                       style={{
//                         margin: 0,
//                         position: "sticky",
//                         top: 0,
//                         background: "#f9fafb",
//                         zIndex: 2,
//                         padding: "16px 8px 8px", // 16px top as you wanted
//                         borderBottom: "1px solid #e5e7eb",
//                       }}
//                     >
//                       {sc.label} ({leads.length})
//                     </h5>

//                     {/* Scroll content */}
//                     <div style={{ padding: 8 }}>
//                       {loading ? (
//                         <Typography.Text type="secondary">
//                           Loading...
//                         </Typography.Text>
//                       ) : leads.length === 0 ? (
//                         <Typography.Text type="secondary">
//                           No leads available
//                         </Typography.Text>
//                       ) : (
//                         leads.map((lead) => (
//                           <LeadCard
//                             key={lead.id}
//                             {...lead}
//                             showCheckbox={false}
//                          showCartIcon={false}
//                             onClick={() => setSelectedLead(lead)}
//                           />
//                         ))
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </Col>
//         </Row>

//         {/* Fixed cart */}
//         {cartLeads.length > 0 && (
//           <div
//             style={{
//               position: "fixed",
//               bottom: 20,
//               left: rightColPos.left,
//               width: rightColPos.width,
//               background: "#fff",
//               border: "1px solid #64a1f7ff",
//               borderRadius: 8,
//               padding: "12px 16px",
//               boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "flex-start",
//               zIndex: 1000,
//             }}
//           >
//             <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//               <span style={{ color: "#007bff", fontSize: 16, fontWeight: 600 }}>
//                 No. of {cartLeads.length === 1 ? "lead" : "leads"} Selected:{" "}
//                 {cartLeads.length}
//               </span>
//               <span style={{ color: "#555", fontSize: 13 }}>
//                 * Lead amount may change while someone purchases the same lead
//                 at a time
//               </span>

//               <span style={{ color: "#ff5454ff", fontSize: 13 }}>
//                 Login required. You’ll be redirected to the sign-in page to
//                 continue.
//               </span>
//             </div>

//             <Button type="primary" onClick={handleAddToCart}>
//               Buy Now
//             </Button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BeforeLoginWeb;


import React, { useRef, useEffect, useState, useMemo } from "react";
import { Row, Col, Card, Typography, Select, Button, Pagination } from "antd";
import {
  FilterOutlined,
  ShoppingCartOutlined,
  CheckOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import "./newDashboard.css";
import useLeadOptions from "../../components/NewDashboard/UseLeadOptions";
import axiosPublic from "../../store/api/axiosPublic";
import useBeforeLoginApi from "../../hooks/useBeforeLoginApi";
import Header from "../../components/Header";
import { formatAmountIndian } from "./FormatAmount";
import LeadCard from "./LeadCard";
import AdminCard from "./AdminCard";

const BeforeLoginWeb = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { Title } = Typography;
  const dispatch = useDispatch();

  const [selectedLead, setSelectedLead] = useState(null);
  const [subcategoryLeadsMap, setSubcategoryLeadsMap] = useState({});
  const [subcategoryLoading, setSubcategoryLoading] = useState({});
  const [lastSearchParams, setLastSearchParams] = useState({});
  const [isHoveredDetail, setIsHoveredDetail] = useState(false); // <--- ADDED MISSING STATE

  const [locations, setLocations] = useState([]);
  const [landTypes, setLandTypes] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [filters, setFilters] = useState({
    location: [],
    landType: [],
    budget: [],
    plotSize: [],
  });

  const filterLeads = location.state?.filters;
  const [filteredLeadsNav, setFilteredLeadsNav] = useState([]);
  const rightColRef = useRef(null);
  const [rightColPos, setRightColPos] = useState({ left: 0, width: 0 });

  // Fetch leads
  const {
    allLeads,
    pagination,
    cartLeads,
    loading,
    fetchAllLeads,
    updateLeadSubCategory,
    addLeadToCart,
    removeLeadFromCart,
  } = useBeforeLoginApi();

  const transformLeadData = (rawLead) => ({
    id: rawLead._id,
    name: rawLead.name,
    place: rawLead.location,
    price: rawLead.budget,
    currentRate: rawLead.currentRate,
    landType: rawLead.subcategory?.label || "",
    rating: `${rawLead.timesBought || 0}/${rawLead.leadAvailableCount || 0}`,
    status: rawLead.status || "",
    siteVisit: rawLead.siteVisitDays?.join(", ") || "",
    lookingFor:
      rawLead.property_details ||
      rawLead.category?.label ||
      "No details provided",
    contact: rawLead.phone,
    type: rawLead.leadType,
    category: rawLead.category,
    sqft: rawLead.spaceSqft || 0,
    subCategoryId: rawLead.subcategory?._id,
    subCategoryLabel: rawLead.subcategory?.label || "",
    subCategoryName: rawLead.subcategory?.name || "",
    state: rawLead.state || "",
    district: rawLead.district || "",
    area: rawLead.area || "",
    pincode: rawLead.pincode || "",
  });

  // Update right column position
  useEffect(() => {
    const updatePosition = () => {
      if (rightColRef.current) {
        const rect = rightColRef.current.getBoundingClientRect();
        setRightColPos({ left: rect.left, width: rect.width });
      }
    };
    updatePosition();
    window.addEventListener("resize", updatePosition);
    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  const fetchFilteredLeadsFromPage = async (filters) => {
    try {
      const URL = "https://apilead.blaccdot.com/api/admin/all-leads";

      const params = {
        state: filters?.state || undefined,
        district: filters?.district || undefined,
        area: filters?.area || undefined,
        pincode: filters?.pincode || undefined,
        category:
          Array.isArray(filters?.landType) && filters.landType.length
            ? filters.landType.join(",")
            : undefined,
        minBudget:
          Array.isArray(filters?.budget) && filters.budget.length === 2
            ? filters.budget[0]
            : undefined,
        maxBudget:
          Array.isArray(filters?.budget) && filters.budget.length === 2
            ? filters.budget[1]
            : undefined,
      };

      Object.keys(params).forEach(
        (key) => params[key] === undefined && delete params[key]
      );

      const res = await axiosPublic.get(URL, { params });
      const leads = res.data?.data || [];
      setFilteredLeadsNav(leads);
    } catch (error) {
      console.error("❌ Filter API error:", error);
      setFilteredLeadsNav([]);
    }
  };

  useEffect(() => {
    if (filterLeads && Object.keys(filterLeads).length > 0) {
      fetchFilteredLeadsFromPage(filterLeads);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [filterLeads, navigate, location.pathname]);

  const apiLeads = Array.isArray(allLeads) ? allLeads : [];

  const leads = apiLeads.map((lead) => ({
    id: lead._id,
    name: lead.name,
    place: lead.location,
    price: lead.budget,
    landType: lead.subcategory?.label || "",
    rating: `${lead.timesBought || 0}/${lead.leadAvailableCount || 0}`,
    status: lead.status || "",
    siteVisit: lead.siteVisitDays?.join(", ") || "",
    lookingFor: lead.property_details || "",
    contact: lead.phone,
    type: lead.leadType,
    category: lead.category,
    sqft: lead.spaceSqft || 0,
    subCategoryId: lead.subcategory?._id,
    subCategoryLabel: lead.subcategory?.label || "",
    subCategoryName: lead.subcategory?.name || "",
    state: lead.state || "",
    district: lead.district || "",
    area: lead.area || "",
    pincode: lead.pincode || "",
  }));

  const priorityLead = leads.find((lead) => {
    const [purchased, total] = (lead.rating || "0/0").split("/").map(Number);
    return total - purchased === 1;
  });

  const adminLead = priorityLead
    ? priorityLead
    : leads[Math.floor(Math.random() * leads.length)] || {};

  const fetchCommonOptions = async (field, setter) => {
    try {
      const res = await axiosPublic.get("admin/publicleads/common", {
        params: { field },
      });

      const options = (res.data?.data || []).map((item) => {
        const val = item.value;
        const label =
          typeof val === "number"
            ? `${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(val)}`
            : `${val?.trim()}`;
        return {
          value: val,
          label: label,
        };
      });

      setter(options);
    } catch (err) {
      console.error(`Failed to load ${field}`, err);
    }
  };

  useEffect(() => {
    fetchCommonOptions("location", setLocations);
    fetchCommonOptions("landType", setLandTypes);
    fetchCommonOptions("budget", setBudgets);
  }, []);

  const subCategoryOptions = [
    { label: "Plot", value: "plot" },
    { label: "Villa", value: "villa" },
    { label: "Apartment", value: "apartment" },
    { label: "Office", value: "office" },
    { label: "Shop", value: "shop" },
  ];

  const selectedLeadIdFromURL = new URLSearchParams(location.search).get(
    "selectedleadid"
  );

  useEffect(() => {
    if (!selectedLeadIdFromURL) return;

    fetchAllLeads(1, {
      ...lastSearchParams,
      leadId: selectedLeadIdFromURL,
    });
  }, [selectedLeadIdFromURL]);

  useEffect(() => {
    if (!selectedLeadIdFromURL || !allLeads.length) return;

    const foundLead = allLeads.find(
      (lead) => lead._id === selectedLeadIdFromURL
    );

    if (foundLead) {
      setSelectedLead(transformLeadData(foundLead));
    }
  }, [allLeads, selectedLeadIdFromURL]);

  const handleLeadCheck = async (lead, isChecked) => {
    if (isChecked) {
      await addLeadToCart(lead);
    } else {
      await removeLeadFromCart(lead.id);
    }
  };

  const handleFilter = () => navigate("/sign-up");

  const handleClearSearchFilter = () => {
    setFilters({
      location: [],
      landType: [],
      budget: [],
      plotSize: [],
    });
    setLastSearchParams({});
    fetchAllLeads(1, {});
    setFilteredLeadsNav([]);
    navigate(location.pathname, { replace: true, state: {} });
  };

  const handleSearch = () => {
    const params = {};

    if (filters.location?.length) {
      params.location = filters.location.join(",");
    }
    if (filters.landType?.length) {
      params.landType = filters.landType.join(",");
    }
    if (filters.budget?.length) {
      params.budget = filters.budget.join(",");
    }

    setLastSearchParams(params);
    fetchAllLeads(1, params);
  };

  const leadsToRender =
    filteredLeadsNav.length > 0
      ? filteredLeadsNav.map(transformLeadData)
      : allLeads.map(transformLeadData);

  const handleAddToCart = async () => {
    navigate("/sign-up");
  };

  const fetchLeadsBySubcategory = async (subcat) => {
    setSubcategoryLoading((p) => ({ ...p, [subcat]: true }));

    try {
      const res = await axiosPublic.get(
        `admin/publicleads/subcategory/${subcat}`
      );

      const leads = Array.isArray(res.data?.data)
        ? res.data.data.map(transformLeadData)
        : [];

      setSubcategoryLeadsMap((prev) => ({
        ...prev,
        [subcat]: leads,
      }));
    } catch (err) {
      console.error(`Failed to fetch ${subcat} leads`, err);
      setSubcategoryLeadsMap((prev) => ({
        ...prev,
        [subcat]: [],
      }));
    } finally {
      setSubcategoryLoading((p) => ({ ...p, [subcat]: false }));
    }
  };

  useEffect(() => {
    subCategoryOptions.forEach((sc) => {
      fetchLeadsBySubcategory(sc.value);
    });
  }, []);

  const sortedSubCategories = useMemo(() => {
    return [...subCategoryOptions].sort((a, b) => {
      const aLen = subcategoryLeadsMap[a.value]?.length || 0;
      const bLen = subcategoryLeadsMap[b.value]?.length || 0;
      return bLen - aLen;
    });
  }, [subCategoryOptions, subcategoryLeadsMap]);

  return (
    <div>
      <Header />
      <div style={{ padding: "20px" }}>
        {/* Page Title & Filters */}
        <Row gutter={16} align="middle" style={{ marginBottom: "16px" }}>
          <Col
            span={7}
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <Title level={4} style={{ margin: 0 }}>
              All Leads
            </Title>

            {filteredLeadsNav.length > 0 && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <Button
                  type="link"
                  size="small"
                  onClick={handleClearSearchFilter}
                  style={{ padding: 0, height: "auto", fontSize: "12px" }}
                >
                  Clear
                </Button>
              </div>
            )}
          </Col>

          <Col span={12}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #DBEAFF",
                borderRadius: 6,
                overflow: "hidden",
                background: "#fff",
                width: "100%",
              }}
            >
              <Select
                mode="multiple"
                className="custom-select"
                placeholder="Select Location"
                style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
                value={filters.location}
                onChange={(values) =>
                  setFilters((prev) => ({ ...prev, location: values }))
                }
                options={locations}
              />

              <Select
                mode="multiple"
                className="custom-select"
                placeholder="Land Type"
                style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
                value={filters.landType}
                onChange={(values) =>
                  setFilters({ ...filters, landType: values })
                }
                options={landTypes}
              />
              <Select
                mode="multiple"
                className="custom-select"
                placeholder="Budget Range"
                style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
                value={filters.budget}
                onChange={(values) =>
                  setFilters({ ...filters, budget: values })
                }
                options={budgets}
              />

              <Button
                type="primary"
                style={{
                  background: "blue",
                  border: "none",
                  borderRadius: 0,
                  padding: "0 24px",
                }}
                onClick={handleSearch}
              >
                Search
              </Button>
            </div>
          </Col>

          <Col span={2} style={{ paddingRight: 0 }}>
            <Button
              type="default"
              onClick={handleClearSearchFilter}
              style={{ border: "1px solid red", color: "red" }}
            >
              Clear
            </Button>
          </Col>

          <Col span={2}>
            <Button
              icon={<FilterOutlined />}
              type="default"
              onClick={handleFilter}
            >
              Notify leads
            </Button>
          </Col>
        </Row>

        {/* Leads & Admin Card */}
        <Row gutter={20}>
          <Col span={7}>
            {leadsToRender.map((lead) => (
              <LeadCard
                key={lead.id}
                {...lead}
                showCheckbox
                checked={cartLeads.some((l) => l.id === lead.id)}
                onCheck={(id, checked) => {
                  if (checked) {
                    addLeadToCart(lead);
                  } else {
                    removeLeadFromCart(id);
                  }
                }}
                onClick={() =>
                  setSelectedLead({
                    ...lead,
                  })
                }
                isSelected={selectedLead?.id === lead.id}
              />
            ))}

            <Pagination
              simple
              showSizeChanger={false}
              current={pagination.page}
              total={pagination.total || 10}
              pageSize={pagination.limit}
              onChange={(page) => fetchAllLeads(page, lastSearchParams)}
            />
          </Col>

          <Col flex="2px">
            <div
              style={{ width: 2, backgroundColor: "#DBEAFF", height: "100%" }}
            />
          </Col>

          <Col span={16} ref={rightColRef}>
            {selectedLead ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 12,
                  }}
                >
                  <Typography.Title level={4} style={{ margin: 0 }}>
                    Lead Details
                  </Typography.Title>
                </div>

              <Card
  style={{
    borderRadius: 6,
    background: "#fafafa",
    marginBottom: 20,
  }}
>
  <Row gutter={[0, 16]}>
    <Col span={6} className="search-select-divider col-padding" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
      <strong>Name</strong>
      <p style={{ margin: 0, overflowWrap: "break-word" }}>{selectedLead.name}</p>
    </Col>
    <Col span={6} className="search-select-divider col-padding" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
      <strong>Contact No.</strong>
      <p style={{ margin: 0, overflowWrap: "break-word" }}>{selectedLead.contact}</p>
    </Col>
    <Col span={6} className="search-select-divider col-padding" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
      <strong>Client Location</strong>
      <p style={{ margin: 0, overflowWrap: "break-word" }}>{selectedLead.place}</p>
    </Col>
    <Col span={6} className="col-padding" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
      <strong>Sq.ft</strong>
      <p style={{ margin: 0, overflowWrap: "break-word" }}>{selectedLead.sqft}</p>
    </Col>
  </Row>

  <Row gutter={[0, 16]} style={{ marginTop: 10 }}>
    <Col span={6} className="search-select-divider col-padding" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
      <strong>Budget</strong>
      <p style={{ margin: 0, overflowWrap: "break-word" }}>₹ {formatAmountIndian(selectedLead.price)}</p>
    </Col>
    <Col span={6} className="search-select-divider col-padding" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
      <strong>Preferred location</strong>
      <p style={{ margin: 0, overflowWrap: "break-word" }}>
        {[
          selectedLead?.state,
          selectedLead?.district,
          selectedLead?.area,
          selectedLead?.pincode,
        ]
          .filter(Boolean)
          .join(" - ")}
      </p>
    </Col>
    <Col span={6} className="search-select-divider col-padding" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
      <strong>Site Visit</strong>
      <p style={{ margin: 0, overflowWrap: "break-word" }}>{selectedLead.siteVisit}</p>
    </Col>
    <Col span={6} className="col-padding" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
      <strong>Looking For</strong>
      <p style={{ margin: 0, overflowWrap: "break-word" }}>{selectedLead.lookingFor}</p>
    </Col>
  </Row>

  {/* DYNAMIC CART & BUY NOW BUTTONS */}
  {(() => {
    const isChecked = cartLeads.some((l) => l.id === selectedLead.id);

    return (
      <Row justify="start" style={{ marginTop: 16 }} gutter={12}>
        {/* Add / Added / Remove Button */}
        <Col>
          <Button
            size="middle"
            onClick={(e) => {
              e.stopPropagation();
              handleLeadCheck(selectedLead, !isChecked);
            }}
            onMouseEnter={() => setIsHoveredDetail(true)}
            onMouseLeave={() => setIsHoveredDetail(false)}
            icon={
              isChecked ? (
                isHoveredDetail ? (
                  <DeleteOutlined style={{ fontSize: 13 }} />
                ) : (
                  <CheckOutlined style={{ fontSize: 13 }} />
                )
              ) : (
                <ShoppingCartOutlined style={{ fontSize: 14 }} />
              )
            }
            style={{
              fontWeight: 600,
              fontSize: 12,
              borderRadius: 6,
              padding: "0 16px",
              height: "32px",
              textTransform: "uppercase",
              transition: "all 0.2s ease",
              backgroundColor: isChecked
                ? isHoveredDetail
                  ? "#ff4d4f"
                  : "#1677ff"
                : isHoveredDetail
                ? "#1677ff"
                : "#ffffff",
              color: isChecked || isHoveredDetail ? "#ffffff" : "#1677ff",
              borderColor: isChecked
                ? isHoveredDetail
                  ? "#ff4d4f"
                  : "#1677ff"
                : "#1677ff",
              boxShadow:
                isChecked || isHoveredDetail
                  ? "0 2px 6px rgba(22, 119, 255, 0.3)"
                  : "0 2px 4px rgba(0,0,0,0.05)",
            }}
          >
            {isChecked ? (isHoveredDetail ? "Remove" : "Added") : "Add"}
          </Button>
        </Col>
      </Row>
    );
  })()}
</Card>
              </>
            ) : (
              <AdminCard
                {...adminLead}
                onTopPickClick={(leadId) =>
                  navigate(`/retail-leads?selectedleadid=${leadId}`)
                }
              />
            )}

            <div
              className="thin-scroll"
              style={{
                display: "flex",
                gap: "16px",
                overflowX: "auto",
                paddingBottom: "8px",
              }}
            >
              {sortedSubCategories.map((sc) => {
                const leads = subcategoryLeadsMap[sc.value] || [];
                const loading = subcategoryLoading[sc.value];

                return (
                  <div
                    className="thin-scroll"
                    key={sc.value}
                    style={{
                      minWidth: 300,
                      maxHeight: 360,
                      background: "#f9fafb",
                      border: "1px solid #e5e7eb",
                      borderRadius: 6,
                      overflowY: "auto",
                    }}
                  >
                    {/* Sticky header */}
                    <h5
                      style={{
                        margin: 0,
                        position: "sticky",
                        top: 0,
                        background: "#f9fafb",
                        zIndex: 2,
                        padding: "16px 8px 8px",
                        borderBottom: "1px solid #e5e7eb",
                      }}
                    >
                      {sc.label} ({leads.length})
                    </h5>

                    {/* Scroll content */}
                    <div style={{ padding: 8 }}>
                      {loading ? (
                        <Typography.Text type="secondary">
                          Loading...
                        </Typography.Text>
                      ) : leads.length === 0 ? (
                        <Typography.Text type="secondary">
                          No leads available
                        </Typography.Text>
                      ) : (
                        leads.map((lead) => (
                          <LeadCard
                            key={lead.id}
                            {...lead}
                            showCheckbox={false}
                            showCartIcon={false}
                            onClick={() => setSelectedLead(lead)}
                          />
                        ))
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>

        {/* Fixed cart */}
        {cartLeads.length > 0 && (
          <div
            style={{
              position: "fixed",
              bottom: 20,
              left: rightColPos.left,
              width: rightColPos.width,
              background: "#fff",
              border: "1px solid #64a1f7ff",
              borderRadius: 8,
              padding: "12px 16px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              zIndex: 1000,
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <span style={{ color: "#007bff", fontSize: 16, fontWeight: 600 }}>
                No. of {cartLeads.length === 1 ? "lead" : "leads"} Selected:{" "}
                {cartLeads.length}
              </span>
              <span style={{ color: "#555", fontSize: 13 }}>
                * Lead amount may change while someone purchases the same lead at a time
              </span>

              <span style={{ color: "#ff5454ff", fontSize: 13 }}>
                Login required. You’ll be redirected to the sign-in page to continue.
              </span>
            </div>

            <Button type="primary" onClick={handleAddToCart}>
              Buy Now
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BeforeLoginWeb;